import React from "react";
import ReactDOM from "react-dom";
import Main from "./containers/Main/";
import * as serviceWorker from "./serviceWorker";

import "./styles.css";

const obj = {
  name: "all is ok",
};

//simple destructuring
const { name } = obj;
console.log(name);

ReactDOM.render(<Main />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
